import { render } from "./InstanceComparison.vue?vue&type=template&id=2459b986&scoped=true"
import script from "./InstanceComparison.vue?vue&type=script&lang=js"
export * from "./InstanceComparison.vue?vue&type=script&lang=js"

import "./InstanceComparison.vue?vue&type=style&index=0&id=2459b986&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2459b986"]])

export default __exports__